import {
  ConditionLogicId,
  DynamicFormType,
  isUnpaidDepositStatus,
  type IAppointmentScopeData,
  type IBrand,
  type IConditionLogicImplementation,
  type IDynamicForm,
} from '@principle-theorem/principle-core/interfaces';
import { type WithRef } from '@principle-theorem/shared';
import { isEqual } from 'lodash';
import { isAppointmentScopeData } from './appointment-conditions';

export interface IAppointmentDepositIsUnpaidConditionConfig {
  isUnpaid: boolean;
}

export class AppointmentDepositIsUnpaidCondition
  implements
    IConditionLogicImplementation<
      IAppointmentScopeData,
      IAppointmentDepositIsUnpaidConditionConfig,
      boolean
    >
{
  conditionId = ConditionLogicId.AppointmentDepositIsUnpaid;
  description = 'Appointment deposit must be unpaid';
  isValidContext = isAppointmentScopeData;

  isTrue(
    config: IAppointmentDepositIsUnpaidConditionConfig,
    context: IAppointmentScopeData
  ): boolean {
    const isUnpaid = isUnpaidDepositStatus(
      context.appointment.deposit?.metadata.status
    );
    return isUnpaid === config.isUnpaid;
  }

  async getForm(
    _brand: WithRef<IBrand>,
    initialValue?: IAppointmentDepositIsUnpaidConditionConfig
  ): Promise<IDynamicForm<boolean>> {
    const isUnpaid = {
      type: DynamicFormType.Select,
      label: 'Deposit Is Unpaid?',
      options: [
        { label: 'Unpaid', value: true },
        { label: 'Paid', value: false },
      ],
      initialValue: initialValue?.isUnpaid ?? true,
      compareWith: isEqual,
    };
    return Promise.resolve({ isUnpaid });
  }

  async getSummary(
    config: IAppointmentDepositIsUnpaidConditionConfig
  ): Promise<string | undefined> {
    return Promise.resolve(
      `Appointment deposit is ${config.isUnpaid ? 'Unpaid' : 'Paid'}`
    );
  }
}
